// taskapi.js
import API from './axiosConfig'; // Use the same axios instance as other API files

// Get all tasks
export const getTasks = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.get('/tasks', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log("Tasks API response:", response.data);
    return response.data.data || response.data || [];
  } catch (error) {
    console.error("Error fetching tasks:", error);
    throw error;
  }
};

// Get tasks by activity ID
export const getTasksByActivityId = async (activityId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.get(`/tasks/activity/${activityId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.data || response.data.tasks || [];
  } catch (error) {
    console.error("Error fetching tasks by activity:", error);
    throw error;
  }
};

// Create a new task
export const createTask = async (taskData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.post('/tasks', taskData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating task:", error);
    throw error;
  }
};

// Create multiple tasks
export const createMultipleTasks = async (tasksArray) => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.post('/tasks/bulk', 
      { tasks: tasksArray },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating multiple tasks:", error);
    throw error;
  }
};

// Update a task
export const updateTask = async (taskId, updatedData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.put(`/tasks/${taskId}`, updatedData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating task:", error);
    throw error;
  }
};

// Delete a task
export const deleteTask = async (taskId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.delete(`/tasks/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting task:", error);
    throw error;
  }
};